import _pickBy from 'hs-lodash/pickBy';
import { ERROR_CALLBACK_TYPES } from 'in-meeting-experience-ui-components/constants/errors';
import { getProxyApiUrl } from 'in-meeting-experience-ui-components/utils/general';
import { propertiesList } from '../../constants/callObject';
import noAuthClient from '../../utils/apiClient';
const API_BASE_V1 = `${getProxyApiUrl()}/in-meeting-experience/v1`;
const API_BASE = `${getProxyApiUrl()}/crm/v3/objects/calls`;
export const fetchCallObjectV2 = data => noAuthClient.post(`${API_BASE_V1}/call-objects`, {
  data: _pickBy(data, value => value !== null && value !== ''),
  errorCallback: ERROR_CALLBACK_TYPES.callObject
});
export const fetchCallObjects = ({
  after,
  limit,
  query,
  meetingId,
  callObjectId,
  meetingExternalUniqueIdPropertyName
}) => {
  return noAuthClient.post(`${API_BASE}/search`, {
    data: {
      after,
      limit,
      sorts: [{
        propertyName: 'hs_createdate',
        direction: 'DESCENDING'
      }],
      filterGroups: [{
        filters: [{
          propertyName: meetingExternalUniqueIdPropertyName,
          operator: 'HAS_PROPERTY'
        }, {
          propertyName: 'hs_call_meeting_id',
          operator: 'EQ',
          value: meetingId
        }, {
          propertyName: 'hs_object_id',
          operator: 'NEQ',
          value: callObjectId
        }]
      }],
      properties: propertiesList,
      query
    }
  });
};
export const fetchCallObjectById = ({
  id
}) => noAuthClient.get(`${API_BASE_V1}/call-objects/${id}`, {
  errorCallback: ERROR_CALLBACK_TYPES.callObject
});